import { useState, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import { AppContext } from 'commons-ui';
import { useHistory } from 'react-router-dom';
import { EWidgetTypes } from '../../utils/constants';

const useWidgetTypeContent = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();

	const handleFilterSubmit = (widgetType: EWidgetTypes) => {
		if (widgetType === EWidgetTypes.LAUNCH_WIDGET) {
			history.push({
				pathname: '/dashboard/notices/createLaunchWidget'
			});
			return;
		}
		history.push({
			pathname: '/dashboard/notices/create'
		});
	};

	const onClose = () => {};

	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const { launchWidgetType } = submittedData;
			if (!isEmpty(launchWidgetType)) {
				handleFilterSubmit(launchWidgetType);
			}
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching Widget Type details', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useWidgetTypeContent;
